import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { KompaktdarstellungTemplateComponent } from '../kompakt-darstellung-template.component';
import { NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { FormatUidPipe } from '../../pipes/format/format-uid.pipe';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { PersonStammMasterDetailEntryMeta, PersonStammVersionDetailEntryMeta } from '../../../core/personstamm-api';
import { TranslatePipe } from '@ngx-translate/core';
import { DayMonthYearDatePipe } from '../../pipes/simple/dayMonthYearDate.pipe';
import { FormatAhvPipe } from '../../pipes/format/format-ahv.pipe';
import { AppPermissionService } from '../../../core/services/app-permission.service';
import { PermissionResponse } from '../../../core/base-api';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

@Component({
  selector: 'cap-kompakt-stammperson',
  templateUrl: './kompakt-stammperson.component.html',
  styleUrls: ['./kompakt-stammperson.component.scss'],
  imports: [NgTemplateOutlet, TranslatePipe, DayMonthYearDatePipe, FormatAhvPipe, FormatUidPipe, NgbTooltip]
})
export class KompaktStammpersonComponent extends KompaktdarstellungTemplateComponent {
  @Input() item: PersonStammVersionDetailEntryMeta;
  @Input() auskunftsperre?: PersonStammMasterDetailEntryMeta.AuskunftsperreEnum;
  hasPermissionAuskunft: boolean;

  @ViewChild('typ00', { static: true }) typ00Template: TemplateRef<any>;
  @ViewChild('typ01', { static: true }) typ01Template: TemplateRef<any>;
  @ViewChild('typ02', { static: true }) typ02Template: TemplateRef<any>;

  constructor(
    protected formatService: FormatConfigService,
    protected location: PlatformLocation,
    protected formatUid: FormatUidPipe,
    protected componentLocation: ComponentLocationStrategy,
    private appPersmissionService: AppPermissionService
  ) {
    super(formatService, 'STAMMPERSON', location, componentLocation);
    keysToTranslate<string>(['PROVISORISCH', 'DEFINITIV', 'HOMONYME']); // PersonStatusEnum
    keysToTranslate<string>(['ALLEINEIGENTUM', 'MITEIGENTUM', 'GESAMTEIGENTUM']); // EigentumsformEnum
    keysToTranslate<string>([
      'LEDIG',
      'VERHEIRATET',
      'GESCHIEDEN',
      'VERWITWET',
      'UNVERHEIRATET',
      'INEINGETRAGENERPARTNERSCHAFT',
      'AUFGELOESTEPARTNERSCHAFT',
      'UNBEKANNT'
    ]); // ZivilstandTypeEnum
    keysToTranslate<string>([
      'ANMERKUNG',
      'ANREDE',
      'AUFGABE',
      'AV_BEMERKUNG',
      'BEWERTUNGSGRUND',
      'BODENBEDECKUNG',
      'DIENSTBARKEIT_GRUNDLAST',
      'EXTERNER_HINWEIS',
      'FUNKTION_BENUTZER',
      'GEBAEUDE',
      'GEBUEHR',
      'GESCHAEFT_BESCHREIBUNG',
      'GESELLSCHAFTSFORM',
      'GESETZLICHES_PFANDRECHT',
      'GLAEUBIGER_ROLLE',
      'SCHULDNER_ROLLE',
      'GRUNDSTUECK_UNTER_ART_LIG',
      'GRUNDSTUECK_UNTER_ART_SDR',
      'KENNZEICHNUNG_GEO_GESCHAEFT',
      'NACHRUECK_RECHT',
      'PERSONEN_GRUPPE',
      'PFANDRECHT',
      'PFANDRECHT_BEMERKUNG',
      'QUALITAET_FLAECHE',
      'RECHTSFORM',
      'RECHTSGRUND',
      'SPRACHE',
      'UID_STATUS',
      'VERTRAGSART',
      'VORMERKUNG'
    ]); // Stammperson.CodeEntry.TypeEnum
    keysToTranslate<string>(['MAENNLICH', 'WEIBLICH', 'UNBEKANNT']); // GeschlechtEnum
    keysToTranslate<string>(['NurOeffentlicheAnmerkungenWerdenAngezeigt']);
    this.hasPermissionAuskunft = this.appPersmissionService.hasPermission(PermissionsEnum.AUSKUNFTSPERRE);
  }

  get hasAuskunftsperre(): boolean {
    return this.auskunftsperre === PersonStammMasterDetailEntryMeta.AuskunftsperreEnum.AUSKUNFT_SPERRE;
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.typ00Template;
  }

  registerTemplates() {
    this.bindTemplates(this.typ00Template, 'STAMMPERSON_TYP00');
    this.bindTemplates(this.typ01Template, 'STAMMPERSON_TYP01');
    this.bindTemplates(this.typ02Template, 'STAMMPERSON_TYP02');
  }

  showPersonendaten(): boolean {
    return !this.hasAuskunftsperre || (this.hasAuskunftsperre && this.hasPermissionAuskunft);
  }
}
